<template>
    <v-app-bar
        app
        color="primary"
        dark
    >
        <router-link :to="{ name: 'home' }">
            <v-img
                alt="Logo"
                src="@/assets/images/logo_white.png"
                max-height="90%"
                max-width="130"
                contain
                class="shrink mx-2"
            ></v-img>
        </router-link>
        <v-spacer></v-spacer>

        <v-toolbar-items>
            <v-btn
                :to="{ name: 'home' }"
                :text="isNavTextVisible"
                :icon="! isNavTextVisible"
                exact
            >
                <v-icon :left="isNavTextVisible">mdi-home</v-icon>
                <template v-if="isNavTextVisible">
                    halaman utama
                </template>
            </v-btn>

            <v-btn
                v-if="$store.get('auth/isAuthenticated')"
                :to="{ name: 'dashboard' }"
                :text="isNavTextVisible"
                :icon="! isNavTextVisible"
                exact
            >
                <v-icon :left="isNavTextVisible">mdi-view-dashboard</v-icon>
                <template v-if="isNavTextVisible">
                    dashboard
                </template>
            </v-btn>
        </v-toolbar-items>

        <v-progress-linear
            :active="isLoading"
            :indeterminate="isLoading"
            absolute
            bottom
            color="white"
        ></v-progress-linear>
    </v-app-bar>
</template>

<script>
export default {
    components: {
    },

    computed: {
        isLoading() {
            return this.$store.get('loader/loading', 'registration')
        },

        isNavTextVisible() {
            return this.$vuetify.breakpoint.smAndUp
        }
    }
}
</script>
